export const objectVals2String = (obj: Record<any, any>): string => {
  return Object.values(obj)
    .map((val) =>
      val?.toString
        ? val.toString()
        : val?.toDateString
        ? val.toDateString()
        : ""
    )
    .join("");
};
